(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["us-inventory"] && !Shopify.designMode) return;
  try {
    (function () {
      document.addEventListener('variant:change', function (evt) {
        var variant = evt.detail && evt.detail.variant;
        if (!variant) return;

        var inventories = window.njInventory || {};
        var strings = window.njInventoryStrings;
        if (!strings) return;

        Object.keys(inventories).forEach(function (productId) {
          var quantities = inventories[productId];
          if (!quantities || !(variant.id in quantities)) return;

          var wrapper = document.getElementById('us-inventory-' + productId);
          if (!wrapper) return;

          var qty = quantities[variant.id] || 0;
          var iconAndText = wrapper.querySelector('.icon-and-text');
          var text = wrapper.querySelector('[data-us-inventory-text]');

          wrapper.classList.toggle('hide', qty <= 0);
          if (iconAndText) {
            iconAndText.classList.toggle('inventory--low', qty > 0 && qty <= 5);
          }
          if (text && qty > 0) {
            var template = qty <= 5 ? strings.low : strings.available;
            text.textContent = template.replace('[count]', qty);
          }
        });
      });
    })();
  } catch(e) { console.error(e); }
})();

})();
